var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:currentColor;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.69,32.04c0-9.72-0.01-19.44,0-29.17c0-2.52,0.03-2.54,2.6-2.55c16.05-0.01,32.1,0.01,48.15-0.04 c1.4,0,1.85,0.49,1.84,1.82c-0.02,19.99-0.02,39.99,0.01,59.98c0,1.25-0.54,1.57-1.66,1.57c-8.03,0-16.05,0.06-24.08,0.05 c-8.35,0-16.69-0.04-25.04-0.09c-1.81-0.01-1.84-0.05-1.84-1.87C5.68,51.85,5.69,41.95,5.69,32.04 C5.69,32.04,5.69,32.04,5.69,32.04z M8.29,2.86c0,19.47,0,38.84,0,58.2c15.85,0,31.61,0,47.4,0c0-19.43,0-38.8,0-58.2 C39.87,2.86,24.15,2.86,8.29,2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.13,50.62c5.54,0,11.08-0.02,16.62,0.04c0.55,0.01,1.09,0.55,1.64,0.84c-0.28,0.49-0.44,1.23-0.85,1.42 c-0.63,0.28-1.43,0.23-2.16,0.23c-10.26,0.01-20.51,0.01-30.77,0c-0.64,0-1.34,0.07-1.9-0.16c-0.48-0.2-0.79-0.8-1.17-1.22 c0.43-0.39,0.83-1.05,1.29-1.1c1.63-0.17,3.29-0.17,4.94-0.17c4.12-0.02,8.24-0.01,12.36-0.01C32.13,50.54,32.13,50.58,32.13,50.62 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.02,45.16c-5.54,0-11.08,0.01-16.62-0.02c-0.51,0-1.12-0.15-1.5-0.45c-0.25-0.2-0.4-0.98-0.22-1.2 c0.32-0.39,0.91-0.78,1.39-0.79c3.2-0.1,6.41-0.14,9.61-0.13c7.97,0.01,15.93,0.06,23.9,0.09c0.94,0,1.86,0.08,1.84,1.29 c-0.02,1.11-0.9,1.22-1.78,1.22C43.1,45.16,37.56,45.16,32.02,45.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.92,37.22c-5.36,0-10.73,0-16.09,0c-0.28,0-0.55-0.02-0.83-0.02c-0.86,0-1.56-0.4-1.39-1.26 c0.09-0.47,0.81-0.91,1.35-1.18c0.37-0.19,0.9-0.07,1.36-0.07c10.45,0,20.91,0,31.36,0c0.41,0,0.83,0.03,1.24,0.03 c0.84,0,1.49,0.3,1.51,1.22c0.02,0.91-0.59,1.27-1.45,1.27c-0.23,0-0.46,0.01-0.69,0.01C42.83,37.22,37.38,37.22,31.92,37.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.29,11.93c-0.26,0.5-0.41,0.89-0.65,1.21c-3.83,5.14-7.68,10.28-11.51,15.42 c-0.51,0.69-1.15,0.97-1.89,0.46c-0.78-0.53-0.63-1.23-0.13-1.9c3.9-5.21,7.78-10.43,11.71-15.62c0.26-0.35,0.95-0.58,1.39-0.52 C48.6,11.03,48.91,11.57,49.29,11.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.53,13.45c-2.06,0-4.13,0.01-6.19-0.01c-0.87-0.01-1.77-0.17-1.79-1.26c-0.03-1.19,0.92-1.35,1.84-1.35 c4.13-0.01,8.26,0,12.38-0.02c0.91,0,1.45,0.44,1.45,1.27c0,0.88-0.5,1.39-1.5,1.37C25.66,13.41,23.6,13.44,21.53,13.45 C21.53,13.44,21.53,13.44,21.53,13.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.48,21.37c-2.06,0-4.13,0.01-6.19,0c-0.89-0.01-1.75-0.21-1.73-1.31c0.01-1.09,0.87-1.3,1.76-1.3 c4.17-0.01,8.35,0,12.52-0.01c0.92,0,1.37,0.49,1.38,1.34c0.01,0.89-0.51,1.3-1.41,1.29C25.7,21.36,23.59,21.37,21.48,21.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.1,16.14c-0.01-2.02,1.83-3.96,3.76-3.97c2.09-0.01,3.98,1.84,3.99,3.9c0.01,2.13-1.77,3.91-3.91,3.91 C33.88,19.98,32.1,18.2,32.1,16.14z M35.97,17.4c0.93,0,1.45-0.6,1.26-1.38c-0.12-0.5-0.84-1.17-1.29-1.17 c-0.44,0-1.13,0.7-1.25,1.2C34.49,16.88,35.08,17.38,35.97,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.72,24.1c-0.02,2.08-1.76,3.81-3.85,3.8c-2.15,0-3.92-1.78-3.89-3.92c0.02-2,1.93-3.9,3.87-3.86 C49.97,20.17,51.74,21.98,51.72,24.1z M47.89,25.35c0.84,0,1.42-0.51,1.23-1.34c-0.12-0.51-0.8-1.23-1.23-1.23 c-0.46,0-1.19,0.68-1.31,1.17C46.39,24.72,46.91,25.33,47.89,25.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.47,29.28c-2.1,0-4.2-0.01-6.3,0c-0.88,0-1.6-0.28-1.61-1.26c-0.01-0.98,0.72-1.29,1.59-1.3 c4.25-0.01,8.5-0.05,12.75,0.05c0.48,0.01,0.94,0.85,1.41,1.3c-0.47,0.4-0.91,1.13-1.4,1.16C25.77,29.36,23.62,29.28,21.47,29.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.97,17.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.94,14.85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarks);
export default __webpack_public_path__ + "static/media/marks.8d3349b2dc892ff0b1835ff3d975a9bf.svg";
export { ForwardRef as ReactComponent };